import styled from '@emotion/styled';
import { colors, Stack, Typography } from '@ui-components/neo.tax';
import { MenuButton as AriaMenuButton, MenuItem as AriaMenuItem } from 'ariakit';

export const MenuButton = styled(AriaMenuButton)({
  backgroundColor: colors.gray[100],
  height: 36,
  width: 36,
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  borderRadius: 18,
});

export const MenuItem = styled(AriaMenuItem)({
  display: 'flex',
  alignItems: 'center',
  fontSize: '1rem',
  lineHeight: '1.25rem',
  color: colors.gray[900],
  justifyContent: 'center',
  cursor: 'pointer',
  width: '100%',
  padding: '0.5rem 1rem',
});

export const StyledStack = styled(Stack)({
  borderWidth: 1,
});

export const StyledLink = styled(Typography)({
  display: 'flex',
  gap: 6,
  alignItems: 'center',
});
